import {
    getTaskList
} from "@/api/task";
const state = {
    rwshBtnPermission: true,
    taskList: {
        params: {
            type: "0",
            sun: "",
            name: "",
            bmbh: "",
            txlx: "",
            status: "",
            rlr: null,
            title: "",
            rlrq: "",
            page: 1,
            pageSize: 10,
        },
        list: {
            item: [],
            count: 0,
            listLoading: true
        }
    },

};
const mutations = {

    saveRwshBtnPermission(state, payload) {
        state.rwshBtnPermission = payload.flag;
    },
    fetchTaskList(state, payload) {
        if (payload.res.code == 0) {
            state.taskList.params = payload.params;
            state.taskList.list.item = payload.res.data;
            state.taskList.list.count = payload.res.count;
            state.taskList.list.listLoading = false;
        }
    },
};
const actions = {

    setRwshBtnPermission(context, payload) {
        context.commit('saveRwshBtnPermission', payload);
    },
    fetchTaskListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getTaskList(payload)
                .then((res) => {
                    context.commit("fetchTaskList", { res, params: payload });
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};
export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
